import './inc/retail_user.js';
import { Fancybox } from '@fancyapps/ui';
import * as bootstrap from 'bootstrap';
// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';

window.Swiper = Swiper;

// Trigger tabs by hash
var triggerTabList = [].slice.call(document.querySelectorAll('.tab-btn'));

triggerTabList.forEach(function(triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = '#' + triggerEl.href.split('#')[1];
    var tabBtn = document.querySelector(hash + '-tab');

    triggerEl.addEventListener('click', function(event) {
        event.preventDefault();
        tabBtn.click();
    });
});

const navbar = document.querySelector('#site-nav');

// Add class to main navbar on scroll

window.addEventListener('scroll', function() {
    let scroll = window.scrollY;
    if (scroll > navbar.offsetTop) {
        navbar.classList.add('scrolled');
    } else {
        navbar.classList.remove('scrolled');
    }
});

// Panzoom

const panzoom = document.querySelector('.panzoom');
const panzoom_reset = document.querySelector('.panzoom-reset');
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll('[data-imgurl]');

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener('click', function(event) {
        myPanzoom.zoomTo(1);
    });
}

for (const link of fpImgLink) {
    link.addEventListener('click', function() {
        fpImgLink.forEach((e) => { e.classList.remove('active-bg') })
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        console.log(imgUrl);
        panZoomImg.src = imgUrl;
    });
}

/*
    Fancybox

    The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
    the carousel is first initilaized. To avoid triggering 3 image view events on every
    Fancybox initCarousel action, an imageview event is triggered on the initCarousel
    event, but "done" events are then ignored for 1 second. After 1 second, image view
    events will be triggered as typical.
*/

// Tracks fancybox image views.
let fancyboxEventBlock = false

/** Abstracted event action handler
 * @param {import('@fancyapps/ui').Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ('undefined' != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ('undefined' != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Bind actions to Fancybox events
Fancybox.bind('[data-fancybox]', {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});

// Fire oi.utils function that wraps all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function() {
    oi.utils.wrap_oi_aspect();
}, false);

// Initialize Search Modal

const modalSearch = document.getElementById('modal-search');
const inputModalSearch = modalSearch.querySelector('input');

// Focus the search input when the user opens the Search Modal
modalSearch.addEventListener('shown.bs.modal', () => {
    inputModalSearch.focus();
});

// Initialize GSAP animations

document.addEventListener('DOMContentLoaded', () => {
    const drifts = document.querySelectorAll('.gsap-drift');
    if (drifts && drifts.length) {
        drifts.forEach(element => {
            gsap.from(element, {
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    end: 'bottom 62%',
                    scrub: 8,
                },
                x: -24,
            });
        });
    }
    const rises = document.querySelectorAll('.gsap-rise');
    if (rises && rises.length) {
        rises.forEach(element => {
            gsap.from(element, {
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    end: 'top 62%',
                    scrub: 4,
                    once: true,
                },
                y: 32,
                opacity: 0,
            });
        });
    }
});

// Initialize Event carousels
//
// Called on load and again after every AJAX filter, because the event list re-renders
// its carousels through innerHTML, which does not run injected <script> tags. Swiper
// parks its instance on the element, so already-initialised carousels are skipped.

const initEventCarousels = () => {
    document.querySelectorAll('.events-carousel').forEach(block => {
        const carousel = block.querySelector('.swiper');
        if (!carousel || carousel.swiper) {
            return;
        }
        new Swiper(carousel, {
            a11y: true,
            keyboard: true,
            slidesPerView: 1,
            pagination: {
                el: block.querySelector('.swiper-pagination'),
            },
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });
    });
};

document.addEventListener('DOMContentLoaded', initEventCarousels);

// oifilter.js calls this after it swaps in new results.
window.afterResultsSuccess = initEventCarousels;

// Initialize Location Card videos

const cardLocationAll = document.querySelectorAll('.card-location');

if (cardLocationAll) {
    document.addEventListener('DOMContentLoaded', () => {
        cardLocationAll.forEach(card => {
            card.addEventListener('mouseenter', () => {
                let id = 'video-location-';
                id += card.getAttribute('data-listing-id');
                oi.video.play(id);
            });
            card.addEventListener('mouseleave', () => {
                let id = 'video-location-';
                id += card.getAttribute('data-listing-id');
                oi.video.pause(id);
                oi.video.play('video-hero');
            });
        });
    });
}
